<template>
  <form class="custom-options">
    <div v-for="option in getCurrentProduct.custom_options" :key="('customOption_' + option.option_id)">
      <AssemblyOption
        v-if="assemblyProduct && option.title === 'Montage'"
        :assembly-product="assemblyProduct"
      >
        <span
          v-for="opval in option.values"
          :key="opval.option_type_id"
          :class="{ active: inputValues[('customOption_' + option.option_id)] == opval.option_type_id, 'btn-check': true }"
        >
          <input
            @change="optionChanged(option)"
            type="radio"
            class="m0 no-outline"
            :name="('customOption_' + option.option_id)"
            :id="('customOption_' + option.option_id + '_' + opval.option_type_id)"
            focus
            :value="opval.option_type_id"
            v-model="inputValues[('customOption_' + option.option_id)]"
            @focus="focusOption(option)"
            @keydown.enter.prevent=""
          ><label class="pl10 lh20 h4 pointer" :for="('customOption_' + option.option_id + '_' + opval.option_type_id)">
            {{ opval.title }}
            <template v-if="opval.sku && assemblyPrice">
              (+ {{ assemblyPrice | price }})
            </template>
          </label>
        </span>
      </AssemblyOption>

      <div v-else-if="option.title !== 'Montage'" class="product-configurator-option">
        <div
          class="configurator-option-note"
          v-if="validation.results && validation.results[('customOption_' + option.option_id)] && validation.results[('customOption_' + option.option_id)].error"
        >
          {{ validation.results[('customOption_' + option.option_id)].message }}
        </div>

        <div
          class="configurator-option-note"
          v-if="option.title == 'Zaunlänge'"
          :style="(focusedValues[('customOption_' + option.option_id)]) ? 'color:#000;' : ''"
        >
          Bitte tragen Sie die gewünschte Zaunlänge in Metern ein:
        </div>

        <div
          class="configurator-option-note"
          v-if="option.title == 'Zaunfarbe'"
          :style="(focusedValues[('customOption_' + option.option_id)]) ? 'color:#000;' : ''"
        >
          Bitte wählen Sie die gewünschte Zaunfarbe:
        </div>

        <div class="row">
          <div class="configurator-option-head col-xs-4">
            {{ option.title }}
          </div>

          <div class="configurator-option-content col-xs-8">
            <div
              v-if="option.type === 'field'"
            >
              <input
                type="text"
                :name="('customOption_' + option.option_id)"
                focus
                v-model="inputValues[('customOption_' + option.option_id)]"
                :placeholder="option.title"
                @change="optionChanged(option)"
                @focus="focusOption(option)"
                @keydown.enter.prevent=""
              ><span
                v-if="getCurrentProduct.price_matrix_fence"
                class="append"
              >m</span>
            </div>
            <div v-else-if="option.type === 'radio'">
              <div class="m5 relative" v-for="opval in option.values" :key="opval.option_type_id">
                <input
                  @change="optionChanged(option)"
                  type="radio"
                  class="m0 no-outline"
                  :name="('customOption_' + option.option_id)"
                  :id="('customOption_' + option.option_id + '_' + opval.option_type_id)"
                  focus
                  :value="opval.option_type_id"
                  v-model="inputValues[('customOption_' + option.option_id)]"
                  @focus="focusOption(option)"
                  @keydown.enter.prevent=""
                ><label class="pl10 lh20 h4 pointer" :for="('customOption_' + option.option_id + '_' + opval.option_type_id)" v-html="opval.title" />
              </div>
            </div>
            <div v-else-if="option.type === 'select' || option.type === 'drop_down'">
              <div class="relative">
                <select
                  @change="optionChanged(option)"
                  v-model="inputValues[('customOption_' + option.option_id)]"
                  :name="('customOption_' + option.option_id)"
                  @focus="focusOption(option)"
                >
                  <option
                    v-for="opval in option.values"
                    :key="opval.option_type_id"
                    :value="opval.option_type_id"
                  >
                    {{ opval.title }}
                  </option>
                </select>
              </div>
            </div>
            <div v-else-if="option.type === 'checkbox'">
              <div class="m5 relative" v-for="opval in option.values" :key="opval.option_type_id">
                <input
                  @change="optionChanged(option)"
                  type="checkbox"
                  class="m0 no-outline"
                  :name="('customOption_' + option.option_id)"
                  :id="('customOption_' + opval.option_type_id)"
                  focus
                  :value="opval.option_type_id"
                  v-model="inputValues[('customOption_' + option.option_id)]"
                  @focus="focusOption(option)"
                  @keydown.enter.prevent=""
                ><label class="pl10 lh20 h4 pointer" :for="('customOption_' + opval.option_type_id)" v-html="opval.title" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { ProductCustomOptions } from '@vue-storefront/core/modules/catalog/components/ProductCustomOptions.ts'
import { customOptionFieldName, selectedCustomOptionValue } from '@vue-storefront/core/modules/catalog/helpers/customOption';
import { mapGetters } from 'vuex';
import rootStore from '@vue-storefront/core/store'
import { parsePriceMatrix, getSortedLengths } from 'theme/helpers/fence'

import AssemblyOption from 'theme/components/core/blocks/Product/Fence/AssemblyOption'

export default {
  mixins: [ProductCustomOptions],
  components: {
    AssemblyOption
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    fenceLength () {
      if (typeof this.$parent.getCalculatedLength !== 'undefined') {
        return Math.floor(this.$parent.getCalculatedLength() + this.$parent.getAdditionalFenceLength())
      }
      return 1
    },
    assemblyPrice () {
      const tierPrices = this.assemblyProduct?.tier_prices
      let tierPrice = tierPrices?.slice().reverse().find(p => this.fenceLength >= p.qty)?.value
      if (!tierPrice) {
        tierPrice = this.assemblyProduct.price_incl_tax
      }
      return tierPrice * this.fenceLength
    }
  },
  data () {
    return {
      focusedValues: {},
      assemblyProduct: {}
    }
  },
  async created () {
    this.addFenceValidationRules()
    this.setFenceDefaultValues()

    const assemblyOption = this.getCurrentProduct.custom_options.find(o => o.title === 'Montage' && o.type === 'select');
    if (assemblyOption) {
      const optionValue = assemblyOption.values.find(v => v.sku)
      this.assemblyProduct = await rootStore.dispatch('product/single', { options: { sku: optionValue.sku } }, { root: true })
    }
  },
  watch: {
    product (newVal, oldVal) {
      if (newVal.id !== oldVal.id && newVal.price_matrix_fence !== 'undefined') {
        this.setFenceDefaultValues()
      }
      for (const option of this.getCurrentProduct.custom_options) {
        this.validateField(option)
      }
    }
  },
  methods: {
    focusOption (option) {
      this.$set(this.focusedValues, 'customOption_' + option.option_id, true)
    },
    addFenceValidationRules () {
      rootStore.dispatch('product/addCustomOptionValidator', {
        validationRule: 'validate-fence-length', // You may add your own custom fields validators elsewhere in the theme
        validatorFunction: (value) => {
          if (typeof value === 'string') {
            value = parseFloat(value.replace(',', '.'))
          }
          const minlength = this.$parent.getMinimumLength();
          const error = value < minlength
          const message = this.$t('The minimum fence length is {minlength}m', { minlength })
          return { error, message }
        }
      })
    },
    setFenceDefaultValues () {
      for (const customOption of this.product.custom_options) {
        const fieldName = customOptionFieldName(customOption)
        this.$set(this.inputValues, fieldName, this.defaultCustomOptionValue(customOption))
        if (customOption.is_require && customOption.type === 'field') { // validation rules are very basic
          this.validation.rules[fieldName] = 'validate-fence-length'
        } else {
          this.validation.rules[fieldName] = 'required'
        }
        this.optionChanged(customOption)
      }
    },
    defaultCustomOptionValue (customOption) {
      switch (customOption.type) {
        case 'field': {
          const lengths = getSortedLengths(parsePriceMatrix(this.getCurrentProduct.price_matrix_fence))
          return this.getCurrentProduct.fence_default_length ? this.getCurrentProduct.fence_default_length : lengths[0]
        }
        case 'select': {
          return customOption.values && customOption.values.length ? customOption.values[0].option_type_id : 0;
        }
        default: {
          return ''
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-tertiary: color(tertiary);
  $color-black: color(black);
  $color-hover: color(tertiary, $colors-background);

  $bg-secondary: color(secondary, $colors-background);
  $color-secondary: color(secondary);
  $color-error: color(error);

  .custom-option > label {
    font-weight: bold;
    margin-bottom: 10px;
  }

  .error {
    color: $color-error;
    padding-top: 5px;
    display: block;
  }
  $color-silver: color(silver);
  $color-active: color(secondary);
  $color-white: color(white);

  .relative label {
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 16px;
    line-height: 30px;
    &:before {
      content: '';
      position: absolute;
      top: 3px;
      left: 0;
      width: 22px;
      height: 22px;
      background-color: $color-white;
      border: 1px solid $color-silver;
      cursor: pointer;
    }
  }
  input[type='radio'], input[type='checkbox']  {
    position: absolute;
    left: 0;
    display: none;
    &:checked + label {
      &:before {
        background-color: $color-silver;
        border-color: $color-silver;
        cursor: pointer;
      }
      &:after {
        content: '';
        position: absolute;
        top: 9px;
        left: 5px;
        width: 11px;
        height: 5px;
        border: 3px solid $color-white;
        border-top: none;
        border-right: none;
        background-color: $color-silver;
        transform: rotate(-45deg);
      }
    }
    &:hover,
    &:focus {
      + label {
        &:before {
          border-color: $color-active;
        }
      }
    }
    &:disabled + label {
      cursor: not-allowed;
      &:hover,
      &:focus {
        &:before {
          border-color: $color-silver;
          cursor: not-allowed;
        }
      }
    }
  }
</style>
